import { Link, NavLink, Outlet } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useAuth } from "../auth/AuthProvider";

function AppLayout() {
    const { logout, isAdmin } = useAuth();

    return (
        <div className="min-vh-100 d-flex flex-column">
            <header className="navbar navbar-expand-lg border-bottom">
                <div className="container-fluid px-3 px-md-4">
                    <Link to="/" className="navbar-brand fw-semibold">ToeMuchData</Link>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#mainNav"
                        aria-controls="mainNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon" />
                    </button>

                    <nav className="collapse navbar-collapse" id="mainNav">
                        <ul className="navbar-nav me-auto">
                            <li className="nav-item">
                                <NavLink to="/" end className="nav-link">Tableau de bord</NavLink>
                            </li>
                            <li className="nav-item d-none d-lg-flex align-items-center text-secondary px-1" aria-hidden="true">•</li>
                            <li className="nav-item">
                                <NavLink to="/controls" end className="nav-link">Contrôles</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/cars" className="nav-link">Véhicules</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/shops" className="nav-link">Ateliers</NavLink>
                            </li>
                            <li className="nav-item d-none d-lg-flex align-items-center text-secondary px-1" aria-hidden="true">•</li>
                            <li className="nav-item">
                                <NavLink to="/controls/rankings" className="nav-link">Classements</NavLink>
                            </li>
                        </ul>

                        <div className="d-flex align-items-center gap-2">
                            {isAdmin && (
                                <NavLink
                                    to="/admin/users"
                                    className="btn btn-outline-secondary btn-sm"
                                    title="Panel admin"
                                    aria-label="Panel admin"
                                >
                                    <i className="bi bi-shield-lock" aria-hidden="true" />
                                </NavLink>
                            )}
                            <button type="button" className="btn btn-outline-danger btn-sm" onClick={logout}>
                                Déconnexion
                            </button>
                        </div>
                    </nav>
                </div>
            </header>

            <main className="container-fluid px-3 px-md-4 py-4 flex-grow-1">
                <Outlet />
            </main>
        </div>
    );
}

export default AppLayout;
